import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getUserDetailsBySmeId } from "../../../AuthContainer/_redux/authAction";
import { useDispatch } from "react-redux";
import { getXrayStatusBySmeId } from "../../Xray/_redux/xrayActions";
import {
  NormalText,
  PrimaryBoldText,
  SmallLightText,
} from "../../../../utils/typographyUtils";
import StandardButton from "../../../shared/formComponents/StandardButton/StandardButton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { XRAY, XRAY_USER_SCORE } from "../../../../data/RouteUrls";
import { SkeletonLoadingAnimation } from "../../../../base/LoadingAnimation";

export default function BusinessImprovementPlanHeader() {
  const dispatch = useDispatch();
  const params = useParams();
  const userId = params.userId;
  const [userData, setUserData] = useState({});
  const [xrayStatus, setXrayStatus] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getUserData = async () => {
    console.log(userId);
    const userDetailsResponse = await dispatch(getUserDetailsBySmeId(userId));
    const xrayStatusResponse = await dispatch(getXrayStatusBySmeId(userId));
    setUserData(userDetailsResponse);
    setXrayStatus(xrayStatusResponse);
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  if (isLoading) {
    return <SkeletonLoadingAnimation height={40} />;
  }

  return (
    <div>
      <div className='pb-2'><span className='font-weight-bold'>Note: </span> This is the Scalability Plan as seen by the client, allowing you to only view their progress.</div>
      <div className="d-flex align-items-center bg-white px-3 py-2 cs-br-8 justify-content-between">
        <div className="d-flex align-items-stretch">
          <Link to={XRAY} className="text-decoration-none">
            <div className="d-flex align-items-center">
              <img src="/assets/images/back.svg" alt="back" />
              <div className="ms-2">
                <NormalText>Back</NormalText>
              </div>
            </div>
          </Link>
          <div className="ms-3">
            <PrimaryBoldText>{userData.companyName}</PrimaryBoldText>
          </div>
          <div className="seperator-line ms-2"></div>
          <div className="ms-2">
            <PrimaryBoldText>Scalability Plan</PrimaryBoldText>
          </div>
        </div>
        {xrayStatus.completed ? (
          <div>
            <Link
              to={XRAY_USER_SCORE.replace(`:userId`, userId)}
              className="text-decoration-none"
            >
              <StandardButton
                text={"View X-ray"}
                color="btn-rounded-success"
                size="btn-xs"
              />
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
}
